import React, {Fragment} from 'react';

import {Filter} from 'presentation/components/Filter';
import {useHealthSearchBar} from './hooks/useHealthSearchBar';
import {HealthSearchBarProps} from './types';
import {Stack} from '@mui/material';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {UnitsFilterDrawer} from 'presentation/modules/booking/shared/ui/components/UnitsFilterDrawer';
import {HealthFilterByLetter} from './components/HealthFilterByLetter';
import {CurrentLocation} from 'presentation/modules/booking/shared/ui/components/CurrentLocation';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {Drawer} from 'presentation/components/Drawer';
import {translations} from 'presentation/translations-new';

const {apply, nearestDates, filter, distance} = translations['pt-br'].commons;

export function HealthSearchBar({
	placeholder,
	readOnly,
	activeStep,
	searchDataTagId,
}: HealthSearchBarProps) {
	const {
		shouldRenderAutocomplete,
		providersNameOptions,
		isGettingProviderNames,
		showFilter,
		handleOpenDrawer,
		filterIsActive,
		drawerButtonTagId,
		showDistanceDrawer,
		openDrawerState,
		handleCloseDrawer,
		distanceFilterAtMaxDistance,
		handleConfirmDistance,
		handleClearDistance,
		showFilterByLetter,
		showCurrentLocation,
		showProfessionalFilters,
		shift,
		PERIODS,
		handleClearShift,
		handleConfirmShift,
		setExternalOpenDateModal,
		externalOpenDateModal,
		availableDates,
		currentSelectedDate,
		handleChangeDate,
		disabledSelectionDate,
		distanceLabel,
		hideElementProfessionalStepIsFavoriteDoctors,
		hideElementUnitStepIsFavoriteDoctors,
	} = useHealthSearchBar({activeStep});

	return (
		<Filter.Root>
			{hideElementProfessionalStepIsFavoriteDoctors ? null : (
				<Stack direction={'row'} gap={1}>
					{shouldRenderAutocomplete ? (
						<Filter.SearchWithAutocomplete
							placeholder={placeholder}
							loadingList={isGettingProviderNames}
							autocompleteConfig={{
								options: providersNameOptions,
							}}
						/>
					) : (
						<Filter.Search
							dataTagId={searchDataTagId}
							placeholder={placeholder}
							readOnly={readOnly}
						/>
					)}

					{showFilter && !hideElementUnitStepIsFavoriteDoctors ? (
						<Fragment>
							<Filter.Button
								onClick={handleOpenDrawer}
								customLabel={distance}
								count={filterIsActive ? distanceLabel : undefined}
								data-tag-id={drawerButtonTagId}
							/>

							<UnitsFilterDrawer
								openDrawerState={openDrawerState}
								handleOpenDrawer={handleOpenDrawer}
								handleCloseDrawer={handleCloseDrawer}
								showDistanceDrawer={showDistanceDrawer}
								distanceFilterAtMaxDistance={distanceFilterAtMaxDistance}
								handleConfirmDistance={handleConfirmDistance}
								handleClearDistance={handleClearDistance}
							/>
						</Fragment>
					) : null}
				</Stack>
			)}

			{showFilterByLetter ? <HealthFilterByLetter /> : null}

			{showProfessionalFilters ? (
				<Stack flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
					<Filter.Date
						dataTagId={{
							openButton: AppointmentBookingEnum.CLICK_DATAS_MAIS_PROXIMAS,
						}}
						currentFirstDate={currentSelectedDate}
						selectFirstDate={handleChangeDate}
						customOpenModalButton={nearestDates}
						customLabelConfirmButton={apply}
						availableDates={availableDates}
						disableConfirmButton={disabledSelectionDate}
						externalOpen={externalOpenDateModal}
						onAbandonModal={() => setExternalOpenDateModal(false)}
					/>
					<Filter.Button onClick={handleOpenDrawer} count={shift ? 1 : undefined} />
					<Drawer.Root
						open={openDrawerState}
						onOpen={handleOpenDrawer}
						onClose={() => handleCloseDrawer(true)}
						width={'420px'}
						sx={{zIndex: 9000}}>
						<Drawer.Header title={filter} onClose={() => handleCloseDrawer(true)} />
						<Drawer.ContentListByCategory categoryList={[PERIODS]} />
						<Drawer.Footer
							firstButtonOnClick={handleClearShift}
							secondButtonOnClick={handleConfirmShift}
						/>
					</Drawer.Root>
				</Stack>
			) : null}

			{showCurrentLocation && !hideElementUnitStepIsFavoriteDoctors ? (
				<CurrentLocation
					dataTagId={AppointmentBookingEnum.CLICK_ALTERAR_LOCALIZACAO}
					flowType={FlowEnum.HEALTH}
				/>
			) : null}
		</Filter.Root>
	);
}
